"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDragDrop = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var Alert_1 = require("../Alert");
var Button_1 = require("../Button");
var FieldFormatter_1 = require("../FieldFormatter");
var FlexView_1 = require("../FlexView");
var Spacer_1 = require("../Spacer");
var TextFormatter_1 = require("../TextFormatter");
var ArrowUp_1 = require("./ArrowUp");
var FileUploaded_1 = require("./FileUploaded");
require("./fileDragDrop.css");
var FileDragDrop = /** @class */ (function (_super) {
    __extends(FileDragDrop, _super);
    function FileDragDrop(props) {
        var _this = _super.call(this, props) || this;
        _this.checkFileType = function (file) {
            return typeof _this.props.acceptedTypes === 'undefined' ||
                _this.props.acceptedTypes.indexOf(file.type) !== -1;
        };
        _this.onChange = function (e) {
            e.target.files !== null && _this.addFileFromFilelist(e.target.files);
            e.target.value = '';
        };
        _this.handleDragOver = function (e) {
            e.preventDefault();
            if (!_this.state.dragging) {
                _this.setState({ dragging: true });
            }
        };
        _this.handleDragLeave = function (_e) {
            if (_this.state.dragging) {
                _this.setState({ dragging: false });
            }
        };
        _this.handleDrop = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.dataTransfer.files) {
                _this.addFileFromFilelist(e.dataTransfer.files);
            }
        };
        _this.onDelete = function (fileToDelete) { return function () {
            _this.setState({
                files: _this.state.files.filter(function (file) { return !(file.name === fileToDelete.name && file.size === fileToDelete.size); }),
            }, _this.checkFilesConstraints);
        }; };
        _this.onSend = function () {
            if (!_this.props.onSend) {
                return;
            }
            _this.props.onSend(_this.state.files);
        };
        _this.state = {
            files: [],
            dragging: false,
            sizeAlert: 'none',
            countAlert: false,
        };
        return _this;
    }
    FileDragDrop.prototype.checkFilesConstraints = function () {
        var _this = this;
        return this.setState(function (prevState) { return ({
            sizeAlert: 
            // eslint-disable-next-line no-nested-ternary
            prevState.files.reduce(function (c, f) { return c + f.size; }, 0) >=
                (_this.props.totalSizeLimit || FileDragDrop.defaultProps.totalSizeLimit)
                ? 'total'
                : prevState.files.reduce(function (carry, file) {
                    return carry ||
                        file.size >= (_this.props.fileSizeLimit || FileDragDrop.defaultProps.fileSizeLimit);
                }, false)
                    ? 'single'
                    : 'none',
            countAlert: (0, function_1.pipe)(O.fromNullable(_this.props.fileCountLimit), O.map(function (limit) { return prevState.files.length > limit; }), O.getOrElse(function () { return false; })),
        }); }, function () { return _this.props.onChange && _this.props.onChange(_this.state.files); });
    };
    FileDragDrop.prototype.addFileFromFilelist = function (fileList) {
        var _this = this;
        var filesToAdd = Array.from(fileList)
            .filter(function (fileToAdd) {
            return _this.state.files.filter(function (file) { return file.name === fileToAdd.name && fileToAdd.size === file.size; })
                .length === 0;
        })
            .filter(this.checkFileType);
        if (filesToAdd.length === 0) {
            return this.setState({ dragging: false }, this.checkFilesConstraints);
        }
        this.setState({ files: this.state.files.concat(filesToAdd), dragging: false }, this.checkFilesConstraints);
    };
    FileDragDrop.prototype.renderContent = function () {
        var _this = this;
        if (this.state.files.length === 0) {
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.props.compact ? ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, className: "arrow-up" }, { children: (0, jsx_runtime_1.jsx)(ArrowUp_1.ArrowUp, {}) }))) : null, (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsxs)(TextFormatter_1.TextFormatter, __assign({ textAlign: "center", borderless: true }, { children: ["Nessun documento caricato", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("b", { children: "Clicca aggiungi oppure trascina qui!" })] })) }))] }));
        }
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 1 }), this.state.files.map(function (file, index) { return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 3 }, { children: (0, jsx_runtime_1.jsx)(FileUploaded_1.FileUploaded, { file: file, onDelete: _this.onDelete(file) }) }), index)); })] }));
    };
    FileDragDrop.prototype.buildInputFile = function (className) {
        return ((0, jsx_runtime_1.jsx)("input", { className: className, type: "file", multiple: true, onChange: this.onChange, accept: this.props.acceptedTypes ? this.props.acceptedTypes.join(',') : '*' }));
    };
    FileDragDrop.prototype.renderAdd = function () {
        return ((0, jsx_runtime_1.jsxs)(Button_1.Button, __assign({ icon: "icon_upload", styleType: "success-inv", className: "file-drag-drop-button", radius: true, size: "sm" }, { children: ["Aggiungi", this.buildInputFile('file-drag-drop-upload')] })));
    };
    FileDragDrop.prototype.renderSend = function () {
        if (this.state.files.length === 0 ||
            typeof this.props.onSend === 'undefined' ||
            this.state.sizeAlert !== 'none' ||
            this.state.countAlert) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ styleType: "success", onClick: this.onSend }, { children: this.props.customSubmitLabel })));
    };
    FileDragDrop.prototype.renderSizeAlert = function () {
        var _a, _b;
        switch (this.state.sizeAlert) {
            case 'none':
                return null;
            case 'single':
                return ((0, jsx_runtime_1.jsxs)(Alert_1.Alert, __assign({ type: "danger" }, { children: ["Non \u00E8 possibile caricare file con dimensioni maggiori di", ' ', (0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Bytes, { size: (_a = this.props.fileSizeLimit) !== null && _a !== void 0 ? _a : FileDragDrop.defaultProps.fileSizeLimit }), "!"] })));
            case 'total':
                return ((0, jsx_runtime_1.jsxs)(Alert_1.Alert, __assign({ type: "danger" }, { children: ["Non \u00E8 possibile caricare file per una dimensione totale maggiore di", ' ', (0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Bytes, { size: (_b = this.props.totalSizeLimit) !== null && _b !== void 0 ? _b : FileDragDrop.defaultProps.totalSizeLimit }), "!"] })));
        }
    };
    FileDragDrop.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.renderSizeAlert(), this.state.countAlert && this.props.fileCountLimit && ((0, jsx_runtime_1.jsxs)(Alert_1.Alert, __assign({ type: "danger" }, { children: ["Non \u00E8 possibile caricare pi\u00F9 di", ' ', this.props.fileCountLimit > 1 ? "".concat(this.props.fileCountLimit, " file") : 'un file'] }))), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "file-drag-drop" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "file-drag-drop-files ".concat(this.state.dragging ? 'dragging' : ''), onDrop: this.handleDrop, onDragOver: this.handleDragOver, onDragLeave: this.handleDragLeave }, { children: (0, jsx_runtime_1.jsxs)(FlexView_1.FlexView, __assign({ hAlignContent: "center", gutters: { tb: 'xs' } }, { children: [(0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 1 }), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12 }, { children: this.renderAdd() })), this.renderContent(), (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 1 })] })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "file-drag-drop-save" }, { children: this.renderSend() }))] }))] }));
    };
    FileDragDrop.defaultProps = {
        fileSizeLimit: 5 * 1024 * 1024,
        totalSizeLimit: 20 * 1024 * 1024,
        customSubmitLabel: 'Invia »',
    };
    return FileDragDrop;
}(React.PureComponent));
exports.FileDragDrop = FileDragDrop;
//# sourceMappingURL=FileDragDrop.js.map